import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import Dashboard from "../../components/Dashboard"
import { ENDPOINTS } from "../../constants"
import actionTypePrefixes from "../../state/actions/actionTypePrefixes"
import {
  performanceComparisonChartHasData,
  top5LdHasData,
  keyItemDataHasData,
  happyHasData,
  arrayValuesHaveData,
  arrayOfItemsWithCountsHasData,
  pulseChecksHasData,
  employeeCountsHasData,
} from "../../utils/object-utils"

import {
  LengthOfService,
  LengthOfServiceAverage,
  HappyScale,
  ChallengesFaced,
  DirectReports,
  Top5LD,
  DoingWell,
  NeedImproving,
  EngagementScoreDoughnut,
  PerformanceScoreDoughnut,
  Freedom,
  PerformanceComparison,
  PulseChecks,
  MeetingNeeds,
  TotalEmployeesBar,
  LabourTurnoverOverall,
} from "../../components/widgets"

class IntelAndInsightsDashboard extends Component {
  static propTypes = {
    onReload: PropTypes.func.isRequired,
  }

  state = {
    // TODO: widget interraction state to go here, e.g. active nine box grid box
    // but beware you might need to pass this down to WidgetContainer in the renderData
    // prop to get `shouldComponentUpdate` to equate to true
  }

  render() {
    const { t, onReload } = this.props // eslint-disable-line react/prop-types
    const { isLoading, errorMessageKey, widgets, loadingFailed } = this.props.dashboard // eslint-disable-line
    const title = t("Dashboards.Names.IntelAndInsights")

    return (
      <Dashboard
        errorMessageKey={errorMessageKey}
        isLoading={isLoading}
        loadingFailed={loadingFailed}
        onReload={onReload}
        title={title}
        widgetData={widgets}
      >
        {performanceComparisonChartHasData(widgets.performanceComparisonChart.data) && (
          <PerformanceComparison
            dashboard={actionTypePrefixes.IntelAndInsights}
            data={widgets.performanceComparisonChart.data}
            appliedFilters={widgets.performanceComparisonChart.filters}
            exportEndpoint={ENDPOINTS.Export.PerformanceComparisonChart}
            columns={3}
            subtitleKey={widgets.performanceComparisonChart.subtitle}
            sampleSize={widgets.performanceComparisonChart.sampleSize}
          />
        )}
        {happyHasData(widgets.happyScale.data) && (
          <HappyScale
            data={widgets.happyScale.data}
            appliedFilters={widgets.happyScale.filters}
            exportEndpoint={ENDPOINTS.Export.HappyScale}
            subtitleKey={widgets.happyScale.subtitle}
            sampleSize={widgets.happyScale.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.engagementScoreDoughnut.data) &&
          widgets.engagementScoreDoughnut.data[0].value > 0 && (
            <EngagementScoreDoughnut
              data={widgets.engagementScoreDoughnut.data}
              appliedFilters={widgets.engagementScoreDoughnut.filters}
              exportEndpoint={ENDPOINTS.Export.EngagementAverageScore}
              subtitleKey={widgets.engagementScoreDoughnut.subtitle}
            />
          )}

        {keyItemDataHasData(widgets.meetingNeeds.data) && (
          <MeetingNeeds
            data={widgets.meetingNeeds.data}
            appliedFilters={widgets.meetingNeeds.filters}
            exportEndpoint={ENDPOINTS.Export.MeetingNeeds}
            subtitleKey={widgets.meetingNeeds.subtitle}
            sampleSize={widgets.meetingNeeds.sampleSize}
          />
        )}

        {arrayValuesHaveData(widgets.performanceScoreDoughnut.data) && (
          <PerformanceScoreDoughnut
            data={widgets.performanceScoreDoughnut.data}
            appliedFilters={widgets.performanceScoreDoughnut.filters}
            exportEndpoint={ENDPOINTS.Export.PerformanceScore}
            subtitleKey={widgets.performanceScoreDoughnut.subtitle}
            sampleSize={widgets.performanceScoreDoughnut.sampleSize}
          />
        )}

        {arrayOfItemsWithCountsHasData(widgets.lengthOfService.data) && (
          <LengthOfService
            data={widgets.lengthOfService.data}
            appliedFilters={widgets.lengthOfService.filters}
            exportEndpoint={ENDPOINTS.Export.LengthOfService}
            sampleSize={widgets.lengthOfService.sampleSize}
          />
        )}

        {employeeCountsHasData(widgets.averageLengthOfService.data) && (
          <LengthOfServiceAverage
            data={widgets.averageLengthOfService.data}
            appliedFilters={widgets.averageLengthOfService.filters}
            exportEndpoint={ENDPOINTS.Export.AverageLengthOfService}
            sampleSize={widgets.averageLengthOfService.sampleSize}
          />
        )}

        {arrayOfItemsWithCountsHasData(widgets.directReports.data) && (
          <DirectReports
            data={widgets.directReports.data}
            appliedFilters={widgets.directReports.filters}
            exportEndpoint={ENDPOINTS.Export.DirectReports}
          />
        )}

        {top5LdHasData(widgets.top5LD.data) && (
          <Top5LD
            data={widgets.top5LD.data}
            appliedFilters={widgets.top5LD.filters}
            exportEndpoint={ENDPOINTS.Export.LAndDStats}
            subtitleKey={widgets.top5LD.subtitle}
            sampleSize={widgets.top5LD.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.doingWell.data) && (
          <DoingWell
            data={widgets.doingWell.data}
            appliedFilters={widgets.doingWell.filters}
            exportEndpoint={ENDPOINTS.Export.DoBest}
            subtitleKey={widgets.doingWell.subtitle}
            sampleSize={widgets.doingWell.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.needsImproving.data) && (
          <NeedImproving
            data={widgets.needsImproving.data}
            appliedFilters={widgets.needsImproving.filters}
            exportEndpoint={ENDPOINTS.Export.NeedsImproving}
            subtitleKey={widgets.needsImproving.subtitle}
            sampleSize={widgets.needsImproving.sampleSize}
          />
        )}

        {false /* SK: disabled by default, need to add a setting for clients who don't want to see this data [non anonymous] */ &&
          pulseChecksHasData(widgets.pulseCheckResponses.data) && (
            <PulseChecks
              data={widgets.pulseCheckResponses.data}
              appliedFilters={widgets.pulseCheckResponses.filters}
              exportEndpoint={ENDPOINTS.Export.PulseChecks}
            />
          )}

        {keyItemDataHasData(widgets.freedom.data) && (
          <Freedom
            data={widgets.freedom.data}
            appliedFilters={widgets.freedom.filters}
            exportEndpoint={ENDPOINTS.Export.Freedom}
          />
        )}

        {keyItemDataHasData(widgets.challengesFaced.data) && (
          <ChallengesFaced
            data={widgets.challengesFaced.data}
            appliedFilters={widgets.challengesFaced.filters}
            exportEndpoint={ENDPOINTS.Export.ChallengesFaced}
            subtitleKey={widgets.challengesFaced.subtitle}
            sampleSize={widgets.challengesFaced.sampleSize}
          />
        )}

        {widgets.totalEmployees.data &&
          widgets.totalEmployees.data.totalEmployeeYears &&
          widgets.totalEmployees.data.totalEmployeeYears.length > 0 && (
            <TotalEmployeesBar
              data={widgets.totalEmployees.data}
              appliedFilters={widgets.totalEmployees.filters}
              exportEndpoint={ENDPOINTS.Export.TotalEmployees}
              sampleSize={widgets.totalEmployees.sampleSize}
            />
          )}

        {keyItemDataHasData(widgets.overallLabourTurnover.data) && (
          <LabourTurnoverOverall
            data={widgets.overallLabourTurnover.data}
            appliedFilters={widgets.overallLabourTurnover.filters}
            exportEndpoint={ENDPOINTS.Export.LabourTurnover}
          />
        )}
      </Dashboard>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.intelAndInsights,
  }
}

export default compose(translate(), connect(mapStateToProps))(IntelAndInsightsDashboard)



// WEBPACK FOOTER //
// ./src/routes/dashboards/IntelAndInsightsDashboard.jsx